<div class="container-fluid">
  <div class="col-1 nopadR" style="cursor: pointer; float: right">
    <img src="assets/images/icons/default_icons/icon-close.png" alt="close" id="closeicon" (click)="closeDialog()" />
  </div>
  <div class="row">
    <div class="col-11 nopadLR GreyDarkest h3Header">ADD ATTACHMENT</div>
  </div>

  <div appDrag (onFileDropped)="uploadFile($event)" class="row marTB24 dragDropBox">
    <div style="text-align: center; margin: 0 auto; display: flex" class="row">
      <div class="col-12 inB">
        <img src="assets/images/icons/default_icons/icon-upload.png" alt="upload" />

        <input
          name="file"
          hidden
          [accept]="allowedFileTypes"
          type="file"
          (change)="onFileSelected($event)"
          #file
          multiple
        />
        <span class="h4Header GreyDarkest">Drag and Drop or </span
        ><span
          class="clearFix Me-PrimaryDark h4Header"
          name="filesbrowsing"
          style="cursor: pointer; margin-left: 0px"
          (click)="file.click()"
          >Browse file(s)</span
        >
        <br />
      </div>
      <div class="col-12 GreyLight mainBodyTxt4 nopadT inB relative" style="line-height: 30px; margin-top: 10px">
        Allowed file types: {{ allowedFileTypes }}
      </div>
    </div>
    <label class="file_error">{{ fileSizeError }}</label>
  </div>

  <div class="row">
    <mat-chip-listbox>
      <mat-chip-option class="chipStyle-Normal marR16" *ngFor="let file of filename">
        <img
          src="assets/images/icons/default_icons/icon-close-mini.png"
          id="closeMiniIconPa"
          class="chipIconRight"
          style="cursor: pointer"
          alt="iconCloseMini"
          (click)="removeParent(file)"
        />
        {{ file }}
      </mat-chip-option>
    </mat-chip-listbox>
  </div>

  <div class="btnDiv marT8">
    <button name="ok" mat-flat-button class="text-btn" [mat-dialog-close]="fileArray">OK</button>
    <button name="cancel" mat-flat-button class="text-btn" [mat-dialog-close]="">CANCEL</button>
  </div>
</div>
